export const getFormatterStringFromNotes = (notes: string) => {
    const plainText = document.createElement("div");
    plainText.innerHTML = notes;
    return plainText.innerText;
}
